<template>
  <div class="mb-6">
    <AppAlert color="info" icon="mdi:magnify" class="mb-2">
      <strong>{{ $tt('form_review.ensure_note') }}</strong>
    </AppAlert>
    <AppAlert :icon="`mdi:arrow-${getDirection('back')}-circle`">
      {{ $tt('form_review.mistake_back') }}
    </AppAlert>
  </div>

  <FormHeading :h="3">{{ $tt('form_review.order_details') }}</FormHeading>
  <AppRow>
    <BasketSummary :form email-visible entry-date-visible />
    <ProductInfoBox :product="form.product" :urgency="form.urgency" />
  </AppRow>

  <v-divider class="mb-7" />
  <AppRow sequence-two unwrapped>
    <AppCol v-for="(applicant, i) in form.applicants">
      <VisaFormReviewApplicant :i :applicant />
    </AppCol>
  </AppRow>

  <AppCheckbox :label="$tt('form_review.checkbox')" :rules="[required]" />
</template>

<script setup lang="ts">
import type { VisaForm } from '~/types';

defineProps<{
  form: VisaForm;
}>();

const { getDirection } = useFormat();
const { required } = useValidation();
</script>